const PREVENT_ERROR_INTERCEPTOR = 'PREVENT-ERROR-INTERCEPTOR';

export default PREVENT_ERROR_INTERCEPTOR;
